import type { HelpFile } from '../../types/help'
import { JobsTestIds } from '../../../testids/JobsTestIds'

export const jobsHelp: HelpFile = {
  docPage: '/docs/jobs/job-scheduler',
  texts: {
    [JobsTestIds.jobsPage]:
      'Every registered background job — scheduled, manual, and integration-driven. Edit the schedule, enable or disable a job, or trigger an ad-hoc run from this list.',
    [JobsTestIds.btnCreateJob]: 'Register a new background job.',
    [JobsTestIds.colSchedule]: null,
    [JobsTestIds.colEnabled]: 'Whether the schedule is active — disabled jobs do not run automatically but can still be triggered manually.',
    [JobsTestIds.colNextRun]: 'Next time the job is expected to run, based on the schedule and current cluster time.',
    [JobsTestIds.colLastRun]: 'When the most recent execution started.',
    [JobsTestIds.colLastStatus]: 'Outcome of the most recent execution — success, failure, or still running.',
  },
}
